import {errorHandler, getSkey, request} from './HttpClient';

function untilNotUndefined(name, cb) { // TODO: move to utils
	if (window[name] === undefined) {
		return setTimeout(untilNotUndefined, 10, name, cb);
	} else {
		return cb();
	}
}

export default class Payment {
	constructor(app) {
		this.app = app;
		const self = this;

		if (!location.pathname.startsWith('/cart') && !location.pathname.startsWith('/order/checkout'))
			return

		const config = self.getConfig();
		if (config !== null) {
			console.debug(config)
			const [mainPaymentType, subPaymentType] = (config['paymentType'] || '').split('_', 2)
			if (config['orderStep'] === 'cart') {
				self.amazonPayCart(config);
			} else if (config['orderStep'] === 'payment' && config['paymentType'] === 'amazonpay') {
				untilNotUndefined('amazonLoginReady', self.amazonPayPayment.bind(self, config));
			} else if (config['orderStep'] === 'verify' && mainPaymentType === 'unzer') {
				self.unzerPreparePayment(config);
			}
		}
	}

	getConfig() {
		const configNode = document.getElementById('js-payment-config');
		return configNode === null ? null : configNode.dataset;
	}

	amazonPayCart(config) {
		const self = this;
		if (!parseInt(config['cartItems'])) {
			console.debug('No items, no payment');
			return
		}

		const checkbox = document.querySelector('.js-amznPay-input');
		checkbox.addEventListener('change', e => {
			const btn = checkbox.closest('.js-popup').querySelector('.js-amzn-btn');
			btn.classList.toggle('hidden', !checkbox.checked)
		})

		window.onAmazonLoginReady = function () {
			console.debug('onAmazonLoginReady', config);
			amazon.Login.setClientId(config['amznClientId']);
			amazon.Login.setUseCookie(true);
		};

		window.onAmazonPaymentsReady = function () {
			console.debug('onAmazonPaymentsReady');

			document.querySelectorAll('.js-amzn-btn').forEach((elem) => {
				console.debug(elem)
				console.debug(elem.id)
				console.debug(elem.dataset)
				OffAmazonPayments.Button(elem.id, config['amznMerchantId'], {
					type: 'PwA',
					size: 'large', // small || medium || large || x-large
					color: self.app.info.lang === "fr" ? "LightGray" : "Gold", // Gold || LightGray || DarkGray
					authorization: function () {
						const loginOptions = {
							scope: 'profile postal_code payments:widget payments:shipping_address payments:billing_address',
							popup: true
						};
						const authRequest = amazon.Login.authorize(loginOptions, config['amznRedirectUrl']);
						console.debug(authRequest)
					},
					onError: function (error) {
						// something bad happened
						console.error(error)
						console.error(error.getErrorCode())
						console.error(error.getErrorMessage())
						self.onAmazonError('cart.authorization', error.getErrorCode(), error.getErrorMessage());
					}
				});
			})
		};

		this.amazonPayLoadScript(config['amznSandboxMode'] === 'True', true);
	};

	amazonPayPayment(config) {
		const self = this;
		let orderReferenceId;

		console.debug('amazonPayPayment %s', config);

		// otherwise we receive BuyerSessionExpired
		amazon.Login.setClientId(config['amznClientId']);

		new OffAmazonPayments.Widgets.AddressBook({
			sellerId: config['amznMerchantId'],
			onOrderReferenceCreate: function (orderReference) {
				const order = orderReference.getAmazonOrderReferenceId();
				console.debug('onOrderReferenceCreate', order, orderReference);
				document.getElementById('orderReferenceId').value = order;
				orderReferenceId = order;
				document.querySelector('.js-submit-btn').disabled = false;
			},

			onAddressSelect: function (response) {
				// do stuff here like recalculate tax and/or shipping1
				//ToDo: perform validShipmentCountries check here and lock submit btn!
				console.debug('onAddressSelect', response);

				// first release, because maybe the last address was blocked
				// by an exclude zip code (deliverytime conf)
				self.app.order.disableSubmitButtonsWithSemaphore(true);
				// then we acquire the submit btn for the following getBuyerInfo request
				self.app.order.disableSubmitButtonsWithSemaphore();
				getSkey()
					.then(skey => {
						request(`/order/pp_amazonpay/getBuyerInfo/${orderReferenceId}`, {
							params: {skey: skey}
						})
							.then(res => res.json())
							.then(res => {
								console.debug(res);
								if (!res.phone || res.phone.length < 3) {
									console.info('Invalid phone'); // TODO: handle here or keep in verify?
								}
								// we are done with the request and can release
								// the following code runs mostly async anyway
								self.app.order.disableSubmitButtonsWithSemaphore(true);
								self.app.order.checkCountry(res.shippingCountry);
								self.app.order.checkZipCode(res.shippingZipCode, res.shippingCountry, data => {
									console.debug('deliverytimeCb', data)
									if (data !== true) {
										// block submitting due to an excluded zip code
										self.app.order.disableSubmitButtonsWithSemaphore();
									}
								});
							})
					})
			},
			design: {
				designMode: 'responsive'
			},
			onError: function (error) {
				// your error handling code
				console.error(error)
				self.onAmazonError('payment.AddressBook', error.getErrorCode(), error.getErrorMessage());
			}
		}).bind('addressBookWidgetDiv');

		new OffAmazonPayments.Widgets.Wallet({
			sellerId: config['amznMerchantId'],
			onPaymentSelect: function (response) {
				console.debug('onPaymentSelect', response);
			},
			design: {
				designMode: 'responsive'
			},
			onError: function (error) {
				// your error handling code
				console.error(error)
				self.onAmazonError('payment.Wallet', error.getErrorCode(), error.getErrorMessage());
			}
		}).bind('walletWidgetDiv');
	};


	amazonPayStartPayment(config, confirmResponse) {
		const self = this;
		OffAmazonPayments.initConfirmationFlow(config['amznMerchantId'], config['amznReferenceId'], function (confirmationFlow) {
			console.debug('initConfirmationFlow', confirmationFlow)

			getSkey()
				.then(skey => {
					request('/order/pp_amazonpay/confirm', {
						method: 'POST',
						params: {
							orderKey: config['orderKey'],
							skey: skey,
						},
					})
						.then(request => request.json())
						.then(data => {
							console.debug(data)
							confirmationFlow.success();
						})
						.catch(error => {
							console.error(error);
							confirmationFlow.error();
							self.handleAmazonError('CONFIRM_FAILED', error);
						});
				});
		});
	}

	onAmazonError(context, errorCode, errorMessage) {
		const self = this;
		request('/order/pp_amazonpay/logError', {
			method: 'POST',
			json: {
				context: context,
				errorCode: errorCode,
				errorMessage: errorMessage,
			},
		})
			.then(request => request.json())
			.then(data => {
				console.debug('Error successful submitted', data)
			})
			.catch(error => {
				console.error('Server error during submitting', error);
			})
			.finally(() => {
				self.handleAmazonError(errorCode, errorMessage);
			});
	}

	handleAmazonError(code, message) {
		const params = new URLSearchParams({
			error: 'payment',
			errorPaymentType: 'amazonpay',
			errorCode: code,
			errorMessage: message,
			errorSource: 'frontend',
		});
		window.location.href = `/cart?${params.toString()}`;
	}

	amazonPayLoadScript(sandboxMode, async, onLoadCallback) {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.async = async;
		if (sandboxMode) {
			script.src = 'https://static-eu.payments-amazon.com/OffAmazonPayments/eur/sandbox/lpa/js/Widgets.js';
		} else {
			script.src = 'https://static-eu.payments-amazon.com/OffAmazonPayments/eur/lpa/js/Widgets.js';
		}
		if (typeof onLoadCallback === 'function')
			script.onload = onLoadCallback
		document.head.appendChild(script)
		return script
	}

	unzerPreparePayment(config) {
		const self = this;
		console.debug('Hello Unzer! Config: %o', config)
		const unzerInstance = new unzer(config['unzerPublicKey']);
		console.debug('unzerInstance', unzerInstance)
		self.unzerInstance = unzerInstance
	}

	unzerStartPayment(config, confirmResponse) {
		const self = this;
		const unzerInstance = self.unzerInstance
		console.info('Start unzer payment')
		console.debug('config', config)
		console.debug('unzerInstance', unzerInstance)
		console.debug('confirmResponse', confirmResponse)

		const options = {locale: `${document.documentElement.lang}-${document.documentElement.dataset.country.toUpperCase()}`}
		const checkout = new window.checkout(confirmResponse['payPageId'], options);
		if (config['unzerSandboxMode'] === 'True' && config['unzerPublicKey'] === 's-pub-2a10lGPqetG9wkgzNjLbb75cyuV5ljtJ') {
			checkout.paymentUrl = 'https://sbx-payment.heidelpay.com'; // FIXME: Monkeypatch for sandbox mode (only for the shared test system)
		}
		console.debug('Checkout', checkout);

		// Initialize the payment page
		checkout.init().then(function () {
			// If successful, open the dialog
			checkout.open();
			console.debug('Checkout', checkout)

			// Add your event listeners for abort or success events
			checkout.abort(function () {
				console.debug('Abort');
				self.app.order.disableSubmitButtons(true);
			})
			checkout.success(function (data) {
				// console.debug('Success', data)
				console.debug('Success', JSON.parse(JSON.stringify(data))); // better for preserved logs, freeze the object
				if (data['isPending'] && data['redirectUrl']) {
					console.info('Success: Unzer client will redirect, it\'s probably a redirect-method');
				} else {
					// if (data.isSuccess === true && data.returnUrl) {
					console.info('Success: onPage-payment was successful. Great. Let\'s redirect the customer by our self!');
					location.href = data['returnUrl'];
				}
			})
			checkout.error(function (error) {
				console.debug('Checkout Error', JSON.parse(JSON.stringify(error)));
				// They wrap the error in an object
				error = error.error === undefined ? error : error.error;
				errorHandler(error.customerMessage || error.message || error || 'Error');
				self.app.order.disableSubmitButtons(true);
			})

		}).catch(function (error) {
			// Handle error when initialize the payment page
			console.error('Caught Error', JSON.parse(JSON.stringify(error)))
			errorHandler(error.customerMessage || error.message || error || 'Error');
		});
	}
}
